import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Autocomplete, Box, Grid, TextField, useTheme, Typography } from '@mui/material'
import { addMinutes, format } from 'date-fns'

import { useGET_meetingsQuery } from 'redux/api/meetingsApi'
import { useGET_groupCourseSessionsQuery } from 'redux/api/sessionsApi'

import BoxTitle from 'components/atoms/BoxTitle'

import { ELEMENT_RADIUS_MID, PRIMARY_YELLOW } from 'utils/customizedTheme'
import { EventNote } from '@mui/icons-material'

import { useNavigate } from 'react-router-dom'
import { FaChalkboardTeacher } from 'react-icons/fa'


const Classroom: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const theme = useTheme()
  const [filter, setFilter] = useState<string | null>('')
  const [inputValue, setInputValue] = useState('')

  const currentDate = format(new Date(), 'PPPP')
  const today = format(new Date(), 'yyyy-MM-dd')
  const { data: sessions } = useGET_groupCourseSessionsQuery({
    page: 1,
    ordering: 'start_datetimie',
    start_date_from: today,
    start_date_to: today,
  })
  const { data: meetings } = useGET_meetingsQuery({ page: 1, start_date_from: today, start_date_to: today })
  const options = [
    { label: 'Meeting', id: 'meeting' },
    { label: 'Group course session', id: 'session' },
  ]

  const list = []

  sessions?.results.forEach((session) => {
    list.push({
      groupId: 'session',
      title: `${session?.group} / ${session?.course}`,
      url: `/sessions/edit/${session.id}`,
      start: format(new Date(session.start_datetime), 'p'),
      end: session.duration_minutes
        ? format(addMinutes(new Date(session.start_datetime), session.duration_minutes), 'p')
        : null,
    })
  })


  return (
    <Box className="transparent-background">
      <Grid container spacing={2}>
        <Grid item xs={12} xl={12}>
          <BoxTitle title={ t('dashboard.daily-schedule') } icon={<FaChalkboardTeacher style={{ fontSize: '26px'}} />} />
        </Grid>
        <Grid item xs={12}>
          {
            list?.filter(item => filter ? item.groupId === filter : true).map((item, index) => 
              <div onClick={() => navigate(item.url)} key={index} className='subject-group-line'> 
                <div className="subject-group-title" style={{ fontWeight: 'normal', fontSize: '14px'}}>{`${item.title}`}</div>
                <div className="subject-group-icons">{`${item.start} - ${item.end}`}</div>
                <span style={{ fontSize: '0.8rem', marginRight: '10px' }}></span> 
              </div>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}

export default Classroom
